import { createContext } from "react";

import { UserRole } from "../types";

export interface UserRoleContextProps {
  currentRole?: UserRole;
}

export const UserRoleContext = createContext<UserRoleContextProps>({});